export default "__VITE_ASSET__BIJIMqrj__"